import { render, staticRenderFns } from "./AttendanceAbsentLogs.vue?vue&type=template&id=5e2d440b&"
import script from "./AttendanceAbsentLogs.vue?vue&type=script&lang=js&"
export * from "./AttendanceAbsentLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports